import { PmsType } from './pms';

export interface PropertiesResponseContract {
    hotels: Property[];
    hotelsCount: number;
}

export interface Property {
    id: number;
    code: string;
    name: string;
    city: string;
    countryCode: string;
    currency: string;
    timezone: string;
    rooms: number;
    pms?: PmsType;
    status: PmsStatus;
    features: any;
    addons: any;
    dataSources: string[];
}

export interface PmsStatus {
    msg: PmsStatusMsg;
    lastUpdate: string;
}

export enum PmsStatusMsg {
    Connecting = 'Connecting',
    Connected = 'Connected',
    DataFlowing = 'Data Flowing',
    NotConnected = 'Not Connected',
}

export interface PropertyForInvitesResponseContract {
    properties: PropertyForInvitesContract;
}

export interface PropertyForInvitesContract {
    hotels: HotelForInviteContract[];
}

export interface HotelForInviteContract {
    id: number;
    code: string;
    name: string;
    city: string;
    countryCode: string;
    enabled: boolean;
    owned: boolean;
    dataSources: HotelDataSourceContract[];
}

export interface HotelDataSourceContract {
    code: string;
    enabled: boolean;
}
